import { toast } from "react-toastify";
import humanize from "underscore.string/humanize";

const parseKey = (key) => {
  return key.split('.').map(segment => humanize(segment)).join(' ')
}

export function renderRailsErrors (error) {
  for (const [key, value] of Object.entries(error)) {

    if (Array.isArray(value)) {
      value.forEach(errorMsg => toast.error(`${parseKey(key)} ${errorMsg}`));
      continue
    }
    if (typeof value === 'object' && value !== null) {
      renderRailsErrors(value)
      continue
    }

    if (typeof value == 'string')
      toast.error(`${key}: ${value}`)
  }
}